export interface VersionInfo {
    buildTimestamp: string;
    version: string;
    gitBranch: string;
    gitHash: string;
}